import {BaseApiService} from "../../../infrastructure/domain-services/base-api-service";

export class AthleteEventsChartApiService extends BaseApiService {}